import React from 'react'

const Lost: React.FC = () => {
	return (
		<>
			<>you are lost</>
		</>
	)
}
export default Lost
